import React, { useEffect, useState } from "react";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaWhatsapp } from "react-icons/fa";
import Breadcrumb from "../Breadcrumb";
import Section from "../Section";
import SectionHeadingStyle3 from "../SectionHeading/SectionHeadingStyle3";
import { pageTitle } from "../../helpers/PageTitle";

const locationData =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3772.759026157075!2d72.83868237482254!3d19.300510746961494!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b08d0c82b6f1%3A0x9b6d319a2b14ce16!2sVenkatesh%20Plaza%2C%20Balaji%20Nagar%2C%20Station%20Road%2C%20Bhayandar%20West%2C%20Thane%2C%20Maharashtra%20401101!5e0!3m2!1sen!2sin!4v1730022200000!5m2!1sen!2sin";

export default function ContactPage() {
  pageTitle("Contact");
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleWhatsApp = (e) => {
    e.preventDefault();
    const phoneNumber = "919152023390"; // WhatsApp number
    const message = `Hello, I'm ${formData.name}. My email is ${formData.email}. Message: ${formData.message}`;
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  return (
    <>
      <Breadcrumb
        title="Contact"
        bgUrl="https://png.pngtree.com/thumb_back/fh260/background/20210814/pngtree-business-gradient-geometric-gray-square-abstract-simple-gray-background-image_759189.jpg"
      />

      {/* Welcome Section */}
      <Section pt="100" pb="60">
        <div className="container text-center">
          <h2 style={{ fontSize: "2rem", color: "#0a2342", marginBottom: "10px" }}>
            Welcome to Riyansh Solar Power Plus Private Limited ☀️
          </h2>
          <p style={{ color: "#555", maxWidth: "700px", margin: "0 auto" }}>
            We’re here to empower your world with clean and sustainable solar solutions.
            Get in touch with us to start your journey toward a brighter, greener future.
          </p>
        </div>
      </Section>

      {/* Contact Form Section */}
      <Section pt="60" pb="133">
        <div className="container">
          <div className="row">
            {/* Left Side - Form */}
            <div className="col-xl-7 col-lg-6">
              <SectionHeadingStyle3
                sectionTitleUp="Have any question?"
                sectionTitle="Write a Message"
              />
              <form onSubmit={handleWhatsApp}>
                <div style={{ marginBottom: "15px" }}>
                  <input
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    style={{
                      width: "100%",
                      padding: "12px",
                      borderRadius: "8px",
                      border: "1px solid #ccc",
                    }}
                  />
                </div>
                <div style={{ marginBottom: "15px" }}>
                  <input
                    type="email"
                    name="email"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    style={{
                      width: "100%",
                      padding: "12px",
                      borderRadius: "8px",
                      border: "1px solid #ccc",
                    }}
                  />
                </div>
                <div style={{ marginBottom: "15px" }}>
                  <textarea
                    name="message"
                    placeholder="Your Message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    style={{
                      width: "100%",
                      height: "120px",
                      padding: "12px",
                      borderRadius: "8px",
                      border: "1px solid #ccc",
                    }}
                  ></textarea>
                </div>
                <button
                  type="submit"
                  style={{
                    backgroundColor: "#0a2342",
                    color: "#fff",
                    border: "none",
                    padding: "12px 25px",
                    borderRadius: "8px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <FaWhatsapp /> Send via WhatsApp
                </button>
              </form>
            </div>

            {/* Right Side - Contact Info */}
            <div className="col-xl-5 col-lg-6">
              <div style={{ paddingLeft: "40px", paddingTop: "40px" }}>
                <SectionHeadingStyle3
                  sectionTitleUp="Contact With Us"
                  sectionTitle="Let’s work together"
                  sectionSubTitle="Providing clean energy solutions and sustainable solar services."
                  className="cs_mb_40"
                />

                <div style={{ lineHeight: "1.8" }}>
                  <p>
                    <FaPhoneAlt style={{ color: "#0a2342", marginRight: "10px" }} />
                    <a href="tel:+919152023390" style={{ color: "inherit", textDecoration: "none" }}>
                      <strong>+91 91520 23390</strong>
                    </a>
                  </p>
                  <p>
                    <FaEnvelope style={{ color: "#0a2342", marginRight: "10px" }} />
                    <a href="mailto:Info@riyanshsolar.com" style={{ color: "inherit", textDecoration: "none" }}>
                      Info@riyanshsolar.com
                    </a>
                  </p>
                  <p>
                    <FaMapMarkerAlt style={{ color: "#0a2342", marginRight: "10px" }} />
                    Office No 3, Venkatesh Plaza, Balaji Nagar, Station Road, Bhayandar West,
                    Thane 401101, Maharashtra
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Section>

      {/* Inline Google Map */}
      <div style={{ width: "100%", height: "400px", marginBottom: "60px" }}>
        <iframe
          src={locationData}
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          title="Riyansh Solar Power Plus Map"
        ></iframe>
      </div>
    </>
  );
}
